/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import moment from 'moment';

import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Section, Loader, Modal } from 'sa-ui';

import { Row, Col } from 'react-bootstrap';

import messages from './onlineSimulatedMessages';

import YearTabs from '../app/common/YearTabs';
import OnlineSimulatedCard from './OnlineSimulatedCard';

import * as helpers from './onlineSimulatedHelpers';

import { getEvaluationsOnline } from './onlineSimulatedActions';

import './OnlineSimulatedContainer.scss';

const OnlineSimulatedContainer = ({ intl, ...props }) => {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(6);
  const [evaluationsFiltered, setEvaluationsFiltered] = useState([]);
  const [evaluationsPaginated, setEvaluationsPaginated] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [evaluationSelected, setEvaluationSelected] = useState([]);
  const [modalMessage, setModalMessage] = useState('');
  const [languageSelected, setLanguageSelected] = useState('');
  const [chosenLanguage, setChosenLanguage] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      props.getEvaluationsOnline();
    }, 100);
    document.body.classList.remove('modal-open');
  }, []);

  useEffect(() => {
    setEvaluationsFiltered(helpers.filterEvaluations(props.evaluationsOnline, year));
  }, [props.evaluationsOnline, year]);

  useEffect(() => {
    setEvaluationsPaginated(helpers.paginate(evaluationsFiltered, page, limit));
  }, [evaluationsFiltered, page]);

  useEffect(() => {
    setModalMessage(
      !evaluationSelected || !evaluationSelected.duration
        ? messages.content
        : evaluationSelected.status === 'ongoing'
        ? messages.contentDurationContinue
        : messages.contentDurationStart,
    );

    if (evaluationSelected.languageSelected) {
      setLanguageSelected(evaluationSelected.languageSelected);
      setChosenLanguage(true);
    }
  }, [evaluationSelected]);

  function handleChangeFilter(name, eventOrValue) {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;

    if (name === 'page') {
      return setPage(value);
    }

    return setYear(value);
  }

  function handleModal(evaluation) {
    setShowModal(true);
    setEvaluationSelected(evaluation);
  }

  function formatDate(date, locale) {
    const format = locale === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    return moment(date).format(format);
  }
  return (
    <Section id="online-simulated-container">
      <Loader show={props.isLoading} />
      <Row className="mb-5">
        <Col>
          <Row>
            <Col>
              <h1 className="page-title">
                <FormattedMessage {...messages.title} />
              </h1>
            </Col>
          </Row>
        </Col>
      </Row>
      <YearTabs
        year={year}
        years={props.years}
        page={page}
        pages={Math.ceil(props.evaluationsOnline.length / limit)}
        onChangePage={(e) => handleChangeFilter('page', e)}
        onChangeYear={(e) => handleChangeFilter('year', e)}
      />
      <Row>
        {evaluationsPaginated.map((d) => (
          <Col key={d.id} className="d-flex" lg={4}>
            <OnlineSimulatedCard
              {...d}
              style={{ paddingBottom: '15px' }}
              onClick={
                d.status === 'applied' || d.status === 'expired' || d.status === 'scheduled'
                  ? undefined
                  : () => handleModal(d)
              }
            />
          </Col>
        ))}
      </Row>
      <Modal
        show={showModal}
        title={`${evaluationSelected.application}  ${evaluationSelected.applicationDisciplines}`}
        message={
          <div>
            <div>
              {modalMessage && (
                <p
                  dangerouslySetInnerHTML={{
                    __html: intl.formatMessage(modalMessage, {
                      timeEnd: evaluationSelected.timeEnd,
                      dateEnd: evaluationSelected.dateEnd
                        ? formatDate(evaluationSelected.dateEnd, intl.locale)
                        : null,
                      duration: evaluationSelected.duration
                        ? evaluationSelected.duration.slice(0, 5)
                        : evaluationSelected.duration,
                    }),
                  }}
                />
              )}
            </div>
            <div>
              {evaluationSelected.languageOption === '1' && (
                <div style={{ marginTop: '20px' }}>
                  <h5>
                    <b>{intl.formatMessage(messages.languageOption)}</b>
                  </h5>

                  <div className="selectLanguage">
                    <label htmlFor="english">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="english"
                        value="en"
                        id="english"
                        onChange={() => setLanguageSelected('en')}
                        checked={languageSelected === 'en'}
                        disabled={chosenLanguage}
                      />
                      {intl.formatMessage(messages.languageEN)}
                    </label>
                    <label htmlFor="spanish">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="spanish"
                        value="es"
                        id="spanish"
                        onChange={() => setLanguageSelected('es')}
                        checked={languageSelected === 'es'}
                        disabled={chosenLanguage}
                      />
                      {intl.formatMessage(messages.languageES)}
                    </label>
                  </div>
                  {chosenLanguage && <div>{intl.formatMessage(messages.prevChosenLanguage)}</div>}
                </div>
              )}
            </div>
          </div>
        }
        onClose={() => setShowModal(false)}
        icon="pe-7s-check"
        buttons={[
          {
            onClick: () => setShowModal(false),
            label: intl.formatMessage(messages.cancel),
          },
          {
            onClick: () =>
              props.history.push({
                pathname: `/online-simulated/${evaluationSelected.idEvaluation}`,
                search: '',
                state: {
                  languageSelected,
                  courseName: evaluationSelected.courseName,
                  idEvaluationOnline: evaluationSelected.idEvaluationOnline,
                  evalutationStatus: evaluationSelected.status,
                  timeEnd: evaluationSelected.timeEnd,
                  dateEnd: evaluationSelected.dateEnd,
                },
              }),
            label: intl.formatMessage(messages.continue),
            disabled: evaluationSelected.languageOption === '1' && !languageSelected,
          },
        ]}
      />
    </Section>
  );
};

const mapStateToProps = ({ onlineSimulated }) => ({ ...onlineSimulated });

export default compose(
  connect(mapStateToProps, { getEvaluationsOnline }),
  injectIntl,
)(OnlineSimulatedContainer);
